/**
 * Product page (desktop only): moves every block after the buy-buttons block from the
 * details column into the media column below the gallery. Restores DOM on mobile.
 */
const DESKTOP_MQ = window.matchMedia('(min-width: 750px)');

function queryLayouts() {
  /** @type {{ sink: HTMLElement; detailsContent: HTMLElement; buyButtons: HTMLElement }[]} */
  const out = [];
  for (const sink of document.querySelectorAll('[data-product-post-atc-sink]')) {
    const grid = sink.closest('[data-product-grid-content]');
    if (!grid) continue;
    const detailsContent = grid.querySelector('.product-details .group-block-content');
    const buyButtons = detailsContent?.querySelector('.buy-buttons-block');
    if (detailsContent && buyButtons) {
      out.push({
        sink: /** @type {HTMLElement} */ (sink),
        detailsContent: /** @type {HTMLElement} */ (detailsContent),
        buyButtons: /** @type {HTMLElement} */ (buyButtons),
      });
    }
  }
  return out;
}

function isPdpTitleBlock(node) {
  return (
    node instanceof HTMLElement &&
    (node.classList.contains('text-block') || node.classList.contains('shopify-block')) &&
    node.querySelector('h1') != null
  );
}

function moveAfterBuyButtonsToSink({ sink, buyButtons }) {
  let node = buyButtons.nextElementSibling;
  while (node) {
    const next = node.nextElementSibling;
    if (!node.classList.contains('view-product-title') && !isPdpTitleBlock(node)) {
      sink.appendChild(node);
    }
    node = next;
  }
}

function restoreAfterBuyButtons({ sink, buyButtons }) {
  const nodes = [...sink.children];
  if (nodes.length === 0) return;
  const fragment = document.createDocumentFragment();
  for (const el of nodes) {
    fragment.appendChild(el);
  }
  buyButtons.after(fragment);
}

function syncProductPostAtcLayout() {
  const desktop = DESKTOP_MQ.matches;
  for (const layout of queryLayouts()) {
    const { sink, buyButtons } = layout;
    if (desktop) {
      moveAfterBuyButtonsToSink(layout);
      sink.hidden = false;
    } else {
      restoreAfterBuyButtons(layout);
      sink.hidden = true;
    }
  }

  document.dispatchEvent(new CustomEvent('pdp-post-atc:synced'));
}

document.addEventListener('DOMContentLoaded', syncProductPostAtcLayout);
DESKTOP_MQ.addEventListener('change', syncProductPostAtcLayout);
document.addEventListener('shopify:section:load', syncProductPostAtcLayout);
window.addEventListener('pagereveal', syncProductPostAtcLayout);
window.addEventListener('pageshow', (event) => {
  if (event.persisted) syncProductPostAtcLayout();
});

// Run once as soon as this module executes to minimize first-paint jump on desktop.
syncProductPostAtcLayout();
